import { combineReducers } from 'redux'
import consoleReducer from './consoleReducer'

const rootReducer = combineReducers({
    console: consoleReducer
});

export default rootReducer